import React from "react";
import { useTranslation } from "react-i18next";
import LegalLayout from "../../components/LegalLayout";
import LegalContentRenderer from "../../components/LegalContentRenderer";
import { LEGAL_CONTENT, LAST_UPDATED } from "../../data/legalContent";

export default function LegalNotice() {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "fr").slice(0, 2);
  const data = LEGAL_CONTENT.legalNotice[lang] || LEGAL_CONTENT.legalNotice.fr;
  const lastUpdated = LAST_UPDATED[lang] || LAST_UPDATED.fr;
  return (
    <LegalLayout title={data.title} lastUpdated={lastUpdated}>
      <LegalContentRenderer sections={data.sections} />
    </LegalLayout>
  );
}
